import * as Sentry from "@sentry/react-router"

import {getLogger} from "../logging"

const logger = getLogger("lib/util/logAndReportError")

export const logAndReportError = (error: unknown, message?: string): void => {
  if (message) {
    logger.error(message, error)
  } else {
    logger.error("Error:", error)
  }

  Sentry.captureException(error)
}
